var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{staticClass:"ml-1",attrs:{"disabled":_vm.isButtonDisabled || _vm.initialDisabled,"title":_vm.buttonTitle,"variant":"primary"},on:{"click":_vm.openPopup}},[[_vm._v(" "+_vm._s(_vm.$t("chatwoot.login"))+" ")]],2)}
var staticRenderFns = []

export { render, staticRenderFns }